import { getFilterConfigItemByColumnType, getFilterConfigItemByColumnTypeAndSelectedOperator, valuesListSelector } from "@common-reducers/TasksFilterPanelThunks";
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { memo, useEffect, useState } from 'react';
import { BetweenPickersFilterRow } from './between_pickers_filter_row';
import FilterRowValueFieldSpecialDateComponent from './filterRowValueFieldSpecialDateComponent';
import { MultiselectFilterValue } from './multiselect_filter_value';
import TextFieldFilterRowShadcn from './text_field_filter_row_shadcn'; // Use new Shadcn component
import { SelectFilterValue } from "./select_filter_value";

// Keeping original props interface
interface FilterRowValueFieldProps {
    isDisableTempId: boolean;
    selectedColumnType: string;
    selectedColumnId: string;
    operatorField: string;
    valueField: any;
    handleChangeValueField: (value: any) => void;
}

function FilterRowValueFieldShadcn({
    isDisableTempId,
    selectedColumnType,
    selectedColumnId,
    operatorField,
    valueField,
    handleChangeValueField,
}: FilterRowValueFieldProps) {

    const selectedFilterItem = useAppSelector((state) => getFilterConfigItemByColumnType(state, selectedColumnType));
    const selectedFilterItemOperator = useAppSelector((state) => getFilterConfigItemByColumnTypeAndSelectedOperator(state, selectedColumnType, operatorField));
    const valueFilterOptionList = useAppSelector((state) => valuesListSelector(state, selectedColumnType, selectedColumnId, operatorField));
    const [componentToDisplay, setComponentToDisplay] = useState<string>('');


    const handleMultiSelectChange = async (newValue: any) => {
        if (Array.isArray(newValue) && newValue.find((itemVal: any) => itemVal.id === undefined && itemVal.label === "Blank")) {
            newValue = 'Blank'
        }
        handleChangeValueField(newValue)
    }
    const handleBetweenDatesChange = (startDate: any, endDate: any) => {
        if (startDate && endDate) {
            startDate = new Date(startDate).getTime()
            endDate = new Date(endDate).getTime()
            handleChangeValueField(startDate + 'isbetween' + endDate)
        }
    };

    const handleChangeTextValueField = (newValue: string) => {
        handleChangeValueField(newValue);
    };

    /* perfect */
    const whichComponentToDisplay = () => {

        const isSpecialDateOrTimelineValue = (selectedFilterItemOperator?.isSpecialDateFilter)

        if (selectedFilterItem.valueInputType === 'text' && !selectedFilterItemOperator?.isHideValueField && !isSpecialDateOrTimelineValue) {
            setComponentToDisplay("TextFieldFilterRow");
        }
        if (selectedFilterItem.valueInputType === 'person' && !selectedFilterItemOperator?.isHideValueField) {
            setComponentToDisplay("MultiselectFilterValuePerson");
        }
        if (selectedFilterItem.valueInputType === 'select' && !isSpecialDateOrTimelineValue && !selectedFilterItemOperator?.isSpecialBetweenDatesFilter && !selectedFilterItemOperator?.isHideValueField) {
            setComponentToDisplay("MultiselectFilterValueSelect");
        }
        if (selectedFilterItemOperator?.isSpecialBetweenDatesFilter) {
            setComponentToDisplay("BetweenPickersFilterRow");
        }
        if (selectedFilterItemOperator?.isMultiselectForTextField) {
            setComponentToDisplay("MultiselectFilterValueSelect");
        }
        if (isSpecialDateOrTimelineValue && !selectedFilterItemOperator?.isSpecialBetweenDatesFilter) {
            setComponentToDisplay("FilterRowValueFieldSpecialDateComponent");
        }
        if (selectedFilterItemOperator?.isSpecialDateSelectFilter || selectedFilterItemOperator?.isSpecialTimelineFilter) {
            setComponentToDisplay("FilterRowValueFieldSpecialSelectDateComponent");
        }

        return "";
    }

    useEffect(() => {
        whichComponentToDisplay()
    }, [selectedFilterItem, selectedFilterItemOperator])


    return (
        <>
            {(() => {
                switch (componentToDisplay) {
                    case "TextFieldFilterRow":
                        return <TextFieldFilterRowShadcn valueField={valueField} handleChangeTextValueField={handleChangeTextValueField} />;
                    case "MultiselectFilterValuePerson":
                        // Ideally we replace this too, but for now reuse existing MUI component wrapped? 
                        // Plan said prioritize text/select inputs first.
                        // I will keep using MultiselectFilterValue for now to avoid breaking complex person/multiselect logic immediately.
                        return <MultiselectFilterValue
                            onSelectionChange={handleMultiSelectChange}
                            isPerson={true}
                            options={valueFilterOptionList}
                            valueField={valueField ?? []}
                            isDisableTempId={isDisableTempId}
                        />;
                    case "MultiselectFilterValueSelect":
                        return <MultiselectFilterValue
                            onSelectionChange={handleMultiSelectChange}
                            options={valueFilterOptionList}
                            valueField={valueField ?? []}
                            isDisableTempId={isDisableTempId}
                        />;
                    case "BetweenPickersFilterRow":
                        return <BetweenPickersFilterRow
                            handleChangeValueField={handleBetweenDatesChange}
                            valueField={valueField}
                        />;
                    case "FilterRowValueFieldSpecialDateComponent":
                        return <FilterRowValueFieldSpecialDateComponent
                            handleChangeValueField={handleChangeValueField}
                            valueField={valueField}
                        />;
                    case "FilterRowValueFieldSpecialSelectDateComponent":
                        return <SelectFilterValue
                            onSelectionChange={handleChangeValueField}
                            options={valueFilterOptionList}
                            valueField={valueField}
                        />;

                    default:
                        return null;
                }
            })()}
        </>
    );
}


export default memo(FilterRowValueFieldShadcn);
